// Display constants for the audit log screen.
//
// The action *list* comes from the API (GET /audit/actions) so a new audited
// action shows up in the filter without a frontend release. These are only the
// human labels; an action with no entry here falls back to a readable form of
// its own name, so the screen never shows a blank column.

export const ACTION_LABELS = {
  'assessment.assigned': 'Assessment assigned',
  'assessment.updated': 'Assessment updated',
  'assessment.end_date_changed': 'Assessment end date changed',
  'assessment.invite_resent': 'Assessment invite resent',
  'student_list.updated': 'Student list updated',
  'student_list.deleted': 'Student list deleted',
  'subscription.assigned': 'Subscription assigned',
  'user.created': 'User created',
  'user.role_changed': 'User role changed',
  'job_role.created': 'Job role created',
  'job_role.updated': 'Job role updated',
  'job_role.status_changed': 'Job role status changed',
  'job_role.closed': 'Job role closed',
  'job_role.deleted': 'Job role deleted',
  'job_role.archived': 'Job role archived',
  'job_role.unarchived': 'Job role restored',
  'mandate.created': 'Mandate created',
  'mandate.updated': 'Mandate updated',
  'mandate.deleted': 'Mandate deleted',
  'drive.scheduled': 'Drive scheduled',
  'drive.rescheduled': 'Drive rescheduled',
  'drive.cancelled': 'Drive cancelled',
  'drive.status_changed': 'Drive status changed',
  'offer.status_changed': 'Offer status changed',
  'institute.created': 'Institute created',
  'institute.updated': 'Institute updated',
  'institute.deleted': 'Institute deleted',
  'campus.updated': 'Campus updated',
  'event.updated': 'Event updated',
  'event.status_changed': 'Event status changed',
  'event.deleted': 'Event deleted',
  'audit_log.exported': 'Audit log exported',
}

// Destructive or security-relevant actions are tinted so they stand out when
// scanning a long list. Colour is never the only signal — the label always says
// what happened.
export const DESTRUCTIVE_ACTIONS = new Set([
  'assessment.students_removed',
  'student_list.deleted',
  'job_role.deleted',
  'mandate.deleted',
  'drive.cancelled',
  'institute.deleted',
  'event.deleted',
  'user.role_changed',
  'audit_log.exported',
])

export const PORTALS = ['ADMIN', 'CORPORATE', 'INSTITUTE', 'STUDENT', 'SYSTEM']

export const PAGE_SIZE = 50

export const DATE_TIME_FORMAT = 'DD MMM YYYY, hh:mm A'

/**
 * Falls back to a readable label for actions this build has not seen yet.
 * @param {string} action Raw action name, e.g. "job_role.created".
 * @returns {string} Human label.
 */
export const labelForAction = (action) => {
  if (!action) return '-'
  if (ACTION_LABELS[action]) return ACTION_LABELS[action]
  const readable = action.replace(/[._]/g, ' ')
  return readable.charAt(0).toUpperCase() + readable.slice(1)
}
